import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/parents-evening/meet')({
    component: RouteComponent,
})

function RouteComponent() {
    return <div>Hello "/_layout/parents-evening/meet"!</div>
}
